module.exports = __webpack_public_path__ + "static/flags/GR-0553ad0b8db3deeb7c965ff7b5139064.gif";